<div class="message-panel">
  <div class="info-panel label-l-grey-bold">{{request.info}}</div>
  <button  *ngIf="request.downloadText" class="ft-btn active" (click)="confirm(messageAction.Download)">{{request.downloadText}}</button>
  <button  *ngIf="request.dashboardText" class="ft-btn active"(click)="confirm(messageAction.Dashboard)">{{request.dashboardText}}</button>
</div>
